import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['input', 'tabs']

  change(event) {
    const value = event.currentTarget.dataset.value
    this.inputTarget.value = value

    this.tabsTargets.forEach((tab) => {
      const active = tab.dataset.value === value
      tab.classList.toggle('font-semibold', active)
      tab.classList.toggle('bg-brand', active)
      tab.classList.toggle('text-white', active)
      tab.classList.toggle('text-ink-muted', !active)
      tab.classList.toggle('hover:bg-brand-soft', !active)
    })
  }

}
